var map = {
	"./b026/nav/nav": [
		666,
		28
	],
	"./b027site/nav/nav": [
		670,
		24
	],
	"./b027sport/nav/nav": [
		674,
		20
	],
	"./bet365luck/nav/nav": [
		676,
		18
	],
	"./betl/nav/nav": [
		680,
		14
	],
	"./common/nav/nav": [
		684,
		10
	],
	"./taiyangcheng018/nav/nav": [
		686,
		8
	],
	"./veniceman/nav/nav": [
		690,
		4
	],
	"./yongligao/nav/nav": [
		692,
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 660;


//////////////////
// WEBPACK FOOTER
// ./src/components/different lazy ^\.\/.*\/nav\/nav$
// module id = 660
// module chunks = 31